/** @type {Styles} */

export const styles = {
  wrapperTablet: (theme) => ({
    marginBottom: 3,
    '& .MuiTextField-root > .MuiInputBase-root > .MuiOutlinedInput-input': {
      color: 'unset',
    },
    '& .MuiTableContainer-root': {
      height: {
        xs: '50vh',
        lg: '60vh',
      },
      overflowY: 'auto',
    },
  }),
  rootDenied: {
    height: '80vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  accordionTableWrapper: ({ breakpoints }) => ({
    overflowY: 'auto',
    width: '100%',
    maxHeight: {
      xs: 'calc(100vh - 350px)',
      sm: '55vh',
      md: '65vh',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
  }),
  profileBox: {
    minWidth: 0,
  },
  profileText: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    textDecoration: 'none',
    overflowWrap: 'break-word',
  },
}
